import { useAssistant } from '../../contexts/AssistantContext'

/**
 * "Ask about this" (agent-1-web W4): opens the assistant with this card's
 * measure in context and SENDS NOTHING. The chip then names the measure and the
 * starters become its three questions; the person decides what to ask.
 *
 * A `<button>`, because it acts rather than navigates. Callers render it
 * behind `ASSISTANT_ENABLED`, read at module scope, so a build without the
 * assistant carries none of it; without a provider it renders nothing anyway.
 */
export function AskAboutThis({ measure, comparison = false }: { measure?: { ref: string; title: string }; comparison?: boolean }) {
  const assistant = useAssistant()
  if (!assistant) return null
  return (
    <button
      type="button"
      className="link-button assistant-ask"
      aria-label={comparison ? 'Ask the assistant' : measure ? `Ask the assistant about ${measure.title}` : 'Ask the assistant about this reading'}
      onClick={(e) => { if (comparison) assistant.clearMeasure(); assistant.openAssistant({ measure, trigger: e.currentTarget }) }}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M21 12a8 8 0 0 1-11.6 7.2L4 21l1.8-5.4A8 8 0 1 1 21 12z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
      {comparison ? 'Ask the assistant' : 'Ask about this'}
    </button>
  )
}
